import React from 'react'

import styles from './styles'

const Paragraph = ({ style, children }) => (
	<div style={{ ...styles, ...style }}>{children}</div>
)

export default Paragraph



// WEBPACK FOOTER //
// ./src/components/format/Paragraph/index.js